import { render } from "./Rating.vue?vue&type=template&id=4e700c06&ts=true"
import script from "./Rating.vue?vue&type=script&lang=ts"
export * from "./Rating.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__